import { addRaterByEmailAction } from './addRaterByEmailAction';
import { deleteRaterAction } from './deleteRaterAction';
import { setApproverAction } from './setApproverAction';
import { RaterLevel } from './models';
import { Language } from '../../../localization/models';
import { saveEditedRaterAction } from './saveEditedRaterAction';
import { updateRaterAction } from './updateRaterAction';
import { useMemo, Dispatch } from 'react';
import { useAppState } from '../../../core/redux/hooks';


/**
 * Returns the actions used to handle CRUD operations on individual raters.
 *
 * @param projId - the database Id for the project whose raters we're working on
 * @param participantId - the database Id for the participant whose raters we're working on
 * @param dispatch - the function which dispatches the API actions in these functions (usually just the default function
 * returned by `useDispatch`)
 */
export const useRaterActions = (projId: number, participantId: number, dispatch: Dispatch<any>) => useMemo(
  () => ({
    addRater:    (levelId: number, email: string, firstName: string, lastName: string) => dispatch(
      addRaterByEmailAction(projId, participantId, levelId, email, firstName, lastName),
    ),
    deleteRater: (raterId: number) => dispatch(deleteRaterAction(projId, participantId, raterId)),
    setApprover: (raterId: number) => dispatch(setApproverAction(projId, participantId, raterId)),

    updateRater: (
                   raterId: number,
                   email?: string,
                   undelivered?: boolean,
                   firstName?: string,
                   lastName?: string,
                   raterLevel?: RaterLevel,
                   language?: Language,
                 ) => {
      dispatch(
        saveEditedRaterAction(
          projId,
          participantId,
          raterId,
          email,
          undelivered,
          firstName,
          lastName,
          raterLevel,
          language,
        ),
      );
      dispatch(
        updateRaterAction(
          projId,
          participantId,
          raterId,
          email,
          undelivered,
          firstName,
          lastName,
          raterLevel?.surveyLevelId,
          language?.languageId,
        ),
      );
    },
  }),
  [participantId, projId, dispatch],
);


export const useRaterData = (projId: number) => useAppState(state => ({
  previousRaters: state.previousRaters?.[`${projId}`],
  raters:         state.projectRaters?.[`${projId}`],
  raterLevels:    state.projectRaterLevels?.[`${projId}`],
  languages:      state.projectLanguages?.[`${projId}`],
}));
